import React, { useState } from 'react';
import { Container, Title } from './styles';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import { SubscriptionsActions, SubscriptionsFilters, SubscriptionsTable } from './components';
import { Box, ThemeProvider, createMuiTheme as createTheme } from '@material-ui/core';
import { useSubscriptionFilter } from './hooks';

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF7417",
      contrastText: "#FFF"
    }
  },
  typography: {
    fontFamily: 'Montserrat, Arial',
    fontSize: 16
  }
})

export default function FaturasV2() {
  const filters = useSubscriptionFilter();
  const [filtersAppliedCount, setFilterAppliedCount] = useState(0);

  const onChangeFilters = (filter) => {
    filters.changeFilters(filter);
    setFilterAppliedCount(prev => prev + 1);
  }

  const clearAllFilters = () => {
    filters.clearAllFilters();
    setFilterAppliedCount(prev => prev + 1);
  }
  
  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

    <ThemeProvider theme={theme}>
      <AdminMenu />
      <Container>
        <Title>Assinaturas Pagarme</Title>
        <Box marginBottom={4}>
          <SubscriptionsFilters
            key={`filter-${filtersAppliedCount}`}
            defaultFilters={filters.filters}
            onChangeFilters={onChangeFilters}
            onClearAllFilters={clearAllFilters}
          />
        </Box>
        <Box marginBottom={4}>
          <SubscriptionsActions
            filters={filters.filters}
          />
        </Box>
        <SubscriptionsTable
          key={`table-${filtersAppliedCount}`}
          filters={filters.filters}
        />
      </Container>
    </ThemeProvider>
    </div>
  );
}